/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Downgrade_Per_UserInputs */



/**
* | output |
* | --- |
* | "/user" |
*
* @param {Sub_Downgrade_Per_UserInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_per_user = /** @type {((inputs?: Sub_Downgrade_Per_UserInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_Per_UserInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("/Nutzer")
	return /** @type {LocalizedString} */ ("/user")
});